/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { IProductDimensionConfigureDropdownViewProps, IProductDimensionConfigureViewProps } from '@msdyn365-commerce/components';
import { INodeProps, Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { IQuickOrderFormViewProps } from './components';
import { IQuickOrderViewProps } from './quick-order';

/**
 * Render product dimension/configure container.
 * @param configure -- Product dimension configuration.
 * @returns Container to have dimension dropdown.
 */
const renderConfigure = (configure?: IProductDimensionConfigureViewProps): JSX.Element | null => {
    if (configure !== undefined) {
        const { containerProps, dropdowns } = configure;

        return (
            <Node {...containerProps}>
                {dropdowns.map(renderConfigureDropdown)}
            </Node>
        );
    }
    return null;

};

/**
 * Render product dimension/configure dropdown.
 * @param dropdown -- Product dimension drop down.
 * @returns Dropdown.
 */
const renderConfigureDropdown = (dropdown: IProductDimensionConfigureDropdownViewProps): JSX.Element => {
    const { containerProps, labelContainerProps, heading, errors, select } = dropdown;

    return (
        <Node {...containerProps}>
            <Node {...labelContainerProps}>
                {heading}
            </Node>
            {errors}
            {select}
        </Node>
    );
};

const renderForm = (form: IQuickOrderFormViewProps, isMobileView: boolean, quickOrderForm: INodeProps, quickOrderProductContent: INodeProps, quickOrderMsgContent: INodeProps, configure?: IProductDimensionConfigureViewProps) => {
    return isMobileView ? (
        <Node {...quickOrderForm}>
            <Node {... quickOrderProductContent}>
                {form.product}
                {renderConfigure(configure)}
                {form.quantity}
                <Node {...quickOrderMsgContent}>
                    {form.userMessage}
                </Node>
                {form.addToCartBtn}
            </Node>
        </Node>
    ) : (
        <Node {...quickOrderForm}>
            <Node {...quickOrderMsgContent}>
                {form.userMessage}
            </Node>
            <Node {... quickOrderProductContent}>
                {form.product}
                {renderConfigure(configure)}
                {form.quantity}
                {form.addToCartBtn}
            </Node>
        </Node>
    );
};

const quickOrderView: React.FC<IQuickOrderViewProps> = props => {
    const {
        isB2B,
        quickOrderProps,
        contentProps,
        form,
        quickOrderForm,
        drawer,
        configure,
        quickOrderFormProductContent,
        quickOrderFormMsgContent,
        quickOrderList,
        isMobileView
    } = props;

    return isB2B ? (
        <Module {...quickOrderProps}>
            <Node {...drawer}>
                <Node {...contentProps}>
                    {renderForm(form as IQuickOrderFormViewProps, isMobileView, quickOrderForm,
                        quickOrderFormProductContent, quickOrderFormMsgContent, configure)}
                </Node>
            </Node>

            {quickOrderList}
        </Module>
    ) : null;
};
export default quickOrderView;
